import React from "react";
import { Box, IconButton, Modal, Typography } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "700px",
  height: "80vh",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 2,
  m: 2,
};
const PreviewDocsDownload = ({ url }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <IconButton onClick={handleOpen}>
        <RemoveRedEyeIcon
          sx={{
            color: "#1876D1",
            fontSize: "25px",
          }}
        />
      </IconButton>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                marginLeft: "10px",
                fontSize: "20px",
                textTransform: "uppercase",
                fontWeight: "bold",
                marginBottom: "10px",
              }}
              component="h2"
            >
              Preview Files
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box
            sx={{
              height: "calc(100% - 50px)",
            }}
          >
            <iframe
              src={url}
              width="100%"
              height="100%"
              title="previewDocs"
            ></iframe>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default PreviewDocsDownload;
